import ButtonVariants from "@core-components/button/ButtonVariants";
import Emoji, { type IEmojiProps } from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import { Group, SimpleGrid, Stack } from "@mantine/core";
import type { ReactNode } from "react";

export interface IListAccountProps {
  children: React.ReactNode;

  label?: ReactNode;
  emoji?: IEmojiProps["emoji"];

  href?: string;

  className?: string;
}

const AccountList: React.FC<IListAccountProps> = ({
  children,

  label,
  emoji,
  href,
  className,
}) => {
  return (
    <Stack className={`w-full ${className}`}>
      {label && (
        <Group className="w-full px-3 py-5 sm:px-6" justify="space-between">
          <SSHeadline>
            {emoji && <Emoji.DYNAMIC emoji={emoji} size={24} />}
            {label}
          </SSHeadline>
          {href && <ButtonVariants.SeeMore href={href} />}
        </Group>
      )}
      <div className="max-w-full md:p-5">
        <SimpleGrid cols={{ base: 1, sm: 2, md: 3, lg: 3, xl: 4 }}>
          {children}
        </SimpleGrid>
      </div>
    </Stack>
  );
};

export default AccountList;
